import * as React from 'react';

export function IconHem(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={54} height={24} fill="none" {...props}>
      <path
        d="M45.738 7.753c-1.773 0-2.947.805-3.752 2.002-.691-1.243-1.98-2.002-3.592-2.002-1.427 0-2.624.667-3.269 1.795V8.052H32.34v11.603h2.877v-6.677c0-1.542.99-2.555 2.28-2.555 1.335 0 2.186.967 2.186 2.51v6.722h2.901v-6.677c0-1.542.967-2.555 2.28-2.555 1.358 0 2.186.967 2.186 2.51v6.722h2.878v-7.528c0-2.579-1.91-4.374-4.19-4.374zM24.881 10.17c1.657 0 2.67.898 3.038 2.371h-6.1c.391-1.45 1.496-2.371 3.062-2.371zm5.916 3.499c0-3.522-2.486-5.94-5.94-5.94-3.453 0-5.962 2.74-5.962 6.124 0 3.408 2.578 6.147 6.17 6.147 2.394 0 4.282-1.105 5.318-2.74l-2.256-1.427c-.576.944-1.635 1.612-3.04 1.612-1.68 0-2.992-1.06-3.337-2.74h8.955c.046-.184.092-.645.092-1.036zM14.245 4v6.239H7.108V4H4v15.655h3.108v-6.63h7.137v6.63h3.108V4h-3.108z"
        fill="#000"
      />
    </svg>
  );
}
